import { render } from "./GoogleAds.vue?vue&type=template&id=ab5c8e02"
import script from "./GoogleAds.vue?vue&type=script&lang=js"
export * from "./GoogleAds.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__